import { useCallback, useState } from "react";
import { useSearchParams } from "react-router";
import { parseSearchParamWithFallback } from "../utilities/searchParamsHelper";

const useTabSearchParams = <T extends string>(
  tabs: readonly T[],
  defaultValue?: T
): { selectedTab: T; onTabChange: (tab: T) => void } => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedTab, setSelectedTab] = useState<T>(() =>
    parseSearchParamWithFallback(searchParams, "tab", tabs, defaultValue)
  );

  const onTabChange = useCallback(
    (tab: T) => {
      setSelectedTab(tab);
      setSearchParams(
        (prev) => {
          prev.set("tab", tab);
          return prev;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return { selectedTab, onTabChange };
};

export default useTabSearchParams;
